export const getValue = (value: string | boolean): boolean => {
  if (value === 'true' || !!value) {
    return true
  }
  if (value === 'false') {
    return false
  }
  return false
}
